<template>
  <div>
    <Table highlight-row ref="currentRowTable" :columns="columns3" :data="data1" style="width:100%;border:none;"></Table>
    <!-- border:1px solid #ff9900; -->
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import store from '../../store'
export default {
  name: 'expandTable',
  props: {
    row: Object,
    from: String, //"uploadlibrary-上传文件夹",workbook-我的工作薄
  },
  data() {
    return {
      columns3: this.mockTableHeader(),
      data1: this.mockTableRows(),
      sliders: this.getSliders(),
      txt: "12342545512",

    }
  },
  inject: ['CreatePage', 'getSliders'],
  methods: {
    mockTableHeader(args) {

      let header = [{
          "title": "文件名",
          "key": "title",
          "width": "805",
          "align": "left"
        },
        {
          "title": "更新时间",
          "key": "lastedittime",
          "width": "805",
          "align": "left"
        }
      ]
      //折叠左侧导航补差
      let offset = 0
      let expand = store.state.user.isLeftExpand
      //console.log("store:"+expand)
      if (expand === undefined) {
        offset = 0
      } else if (!expand) {
        if (this.from === "uploadlibrary") {
          offset = 58;
        } else if (this.from === "workbook") {
          offset = 85;
        }

      }
      //console.log("offset:"+offset)
      //若无参数则按当前分屏数计算
      if (args === undefined) {
        var len = this.getSliders().length
        if (len === 0) {
          args = 1
        } else if (len === 1) {
          args = 2
        } else if (len > 1) {
          args = 3
        }
      }
      //console.log("args:" + args)
      let da = [];
      var items = header //this.row.children.header;
      let sp = 1; //计算当前分屏数
      if (args === 1) {
        sp = 1
      } else if (args === 2) {
        sp = 2
      } else if (args > 2) {
        sp = 3
      }
      // console.log("child...")
      // console.log(this.row)
      //console.log(this.from)
      if (items == undefined || items.length === 0) { return } //此行的children无数据
      for (var i = 0; i < items.length; i++) {
        let w = items[i].width;
        //根据分屏数动态计算展开表格的列宽
        switch (sp) {
          case 1:
            w = parseInt(items[i].width) + offset
            break;
          case 2:
            w = parseInt(items[i].width / 2) + 5
            break;
          case 3:
            //3屏模式下-30调整偏移量
            w = parseInt(items[i].width / 3) - 20
            break;
        }

        if (items[i].key == "title") {
          da.push({
            title: items[i].title,
            key: items[i].key,
            //width:w + "px",
            align: items[i].align,
            render: (h, params) => {
              const row = params.row;
              const text = row.title;
              const fileid = row.bookid;
              return h('a', {
                on: {
                  'click': () => {
                    this.add(fileid, 2,text);
                    // this.showfilename=true;
                  }
                }
              }, text);
            }
          })

        } else {
          da.push({
            title: items[i].title,
            key: items[i].key,
            //width:w + "px", //items[i].width,
            align: items[i].align,
          })
        }

      }
      return da;
    },
    // add(fid, orderid) {
    //   this.CreatePage(fid, orderid);
    // },
    add(fid, orderid, filename) {
      this.CreatePage(fid, orderid, filename);
    },
    mockTableRows() {
      //console.info(parseInt(6/4));
      //let rows = this.row.children.tabrows;
      let rows = this.row.historyversion
      // console.log("rows...")
      console.log(rows)
      return rows;
    },

    reloadHeaderData(obj) {
      this.columns3 = this.mockTableHeader(obj)
      // this.$nextTick()
    },

  },
  computed: {
    ...mapGetters(['getLeftExpand'])
  },
  watch: {
    sliders: function() {
      //console.log(this.sliders.length)
      if (this.sliders.length === 0) {
        this.reloadHeaderData(1);
      } else if (this.sliders.length === 1) {
        this.reloadHeaderData(2);
      } else if (this.sliders.length > 1) {
        this.reloadHeaderData(3);
      }
    },
    getLeftExpand: function() {
      //console.log(this.getLeftExpand)
      this.reloadHeaderData(1);
    },
  },
}

</script>
<style scoped>
/*td.ivu-table-expanded-cell {
  padding:10px 10px;
  background:#f8f8f9;
}*/

</style>
<style>
.ivu-table:before {
  /*background-color:white;*/
}

</style>
